import {DataGridPro as MuiDataGrid, GridSlotsComponentsProps} from '@mui/x-data-grid-pro';
import {CheckBoxOutlined, IndeterminateCheckBoxOutlined,} from '@mui/icons-material';

export default function DataGrid({
  gridRef,
  ...props
}: Parameters<typeof MuiDataGrid>[0] & { gridRef?: any }) {
  return (
    <MuiDataGrid
      ref={gridRef}
      {...props}
      componentsProps={{
        ...props.componentsProps as  GridSlotsComponentsProps,
        baseCheckbox: {
          checkedIcon: <CheckBoxOutlined />,
          indeterminateIcon: <IndeterminateCheckBoxOutlined />,
        },
      }}
    />
  );
}
